import { handleAxiosError } from "../utils/errorHandler";
import axiosInstance from "./axiosInstance";

export const fetchAllRequests = async () => {
  try {
    const response = await axiosInstance.get(`/api/requests`);
    return { success: true, data: response.data };
  } catch (error) {
    const { status, message } = handleAxiosError(
      error,
      "Chyba při načítání požadavků."
    );
    return { success: false, status, message };
  }
};

export const createRequest = async (typPozadavku, predmet, text) => {
  try {
    const response = await axiosInstance.post(`/api/requests`, {
      typPozadavku,
      predmet,
      text,
    });
    return { success: true, data: response.data };
  } catch (error) {
    const { status, message } = handleAxiosError(
      error,
      "Chyba při vytvoření požadavku."
    );
    return { success: false, status, message };
  }
};

export const fetchRequestsTypes = async () => {
  try {
    const response = await axiosInstance.get(`/api/requests/types`);

    return { success: true, data: response.data };
  } catch (error) {
    const { status, message } = handleAxiosError(
      error,
      "Chyba při načítání typu požadavků."
    );
    return { success: false, status, message };
  }
};
